<template>
  <div class="list">
    <Bread></Bread>
    <div>
      <div class="list-detail-container">
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <div class="item-year">2022-now</div>
          <div class="item-img">
            <img :src="item.url" alt="">
          </div>
          <div class="item-content">
            <div class="item-title">
              {{item.title}}
            </div>
            <div class="item-article">
              {{item.article }}
            </div>
            <div class="item-readMore">readMore</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bread from "./Bread.vue";
export default {
  components: {
    Bread,
  },
  name: "List",
  data() {
    return {
      list:[
        {
           url:require('../../assets/images/history/1.png'),
          title:'Working Group 46: Joint PICES/ICES Working Group on Ocean Negative Carbon Emissions (ONCE)',
          article:" The Working Group 46 a joint PICES/ICES working group on Ocean Negative Carbon Emissions (ONCE) was formed with all members been officially assigned on 6th April 2021. WGONCE has consisted of 25 members including two Co-Chairs representing PICES, Drs. Nianzhi Jiao (China) and Douglas Wallace (Canada), and the two Co-Chairs representing ICES, Drs. Carol Robinson (UK) and Louis Legendre (France)...."
        }
      ]
    };
  },
};
</script>

<style lang="less" scoped>
header {
  background-color: rgb(0 0 0 / 10%);
}
.list {
  position: relative;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
.list-header {
  height: 40px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-item { 
  padding: 20px 30px 20px 20px;
  position: relative;
  height: 220px;
  background-color: #f8f9fb;
  display: flex;
  flex-direction: row;
}
.list-detail-container {
  padding: 0 100px 15px 100px;
}
.item-year {
  background-color: #032f6d;
  font-family: FZZongYi-M05S;
  font-weight: 400;
  color: #ffffff;
  width: 110px;
  height: 28px;
  position: absolute;
  right: 18px;
  top: -15px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.item-img {
  margin-right: 30px;
  width: 450px;
  height: 280px;
}
.item-content {
  width: 80%;
}
.item-title {
  font-size: 20px;
  font-family: Adobe Heiti Std;
  font-weight: bold;
  color: #000000;
  line-height: 30px;
}
.item-article {
  font-size: 16px;
  font-family: Arial;
  font-weight: 400;
  color: #5c5c5c;
}
.item-readMore {
  font-size: 16px;
  font-family: FZZongYi-M05S;
  font-weight: 400;
  color: #032f6d;
}
/deep/.el-menu {
  background-color: unset;
}
</style>
